module.exports = __webpack_public_path__ + "img/compbenchmark.aab86dc5.svg";